import personalInfoKeys from "@swa-ui/personal-info/i18nKeys";

import NewUsernameFormFieldI18nKeys from "./form/NewUsernameFormField/NewUsernameFormField.i18n";
import PersonalInfoFormFieldsI18nKeys from "./form/PersonalInfoFormFields/PersonalInfoFormFields.i18n";
import RapidRewardsNumberFormFieldI18nKeys from "./form/RapidRewardsNumberFormField/RapidRewardsNumberFormField.i18n";
import SecurityQuestionsFormFieldI18nKeys from "./form/SecurityQuestionsFormField/SecurityQuestionsFormField.i18n";
import UsernameFormFieldI18nKeys from "./form/UsernameFormField/UsernameFormField.i18n";
import LoyaltyTierBadgeI18nKeys from "./LoyaltyTierBadge/LoyaltyTierBadge.i18n";
import RapidRewardsNumberI18nKeys from "./RapidRewardsNumber/RapidRewardsNumber.i18n";

export default {
  ...LoyaltyTierBadgeI18nKeys,
  ...NewUsernameFormFieldI18nKeys,
  ...PersonalInfoFormFieldsI18nKeys,
  ...personalInfoKeys,
  ...RapidRewardsNumberFormFieldI18nKeys,
  ...RapidRewardsNumberI18nKeys,
  ...SecurityQuestionsFormFieldI18nKeys,
  ...UsernameFormFieldI18nKeys,
};
